import { render, staticRenderFns } from "./Hotspots_Edit.vue?vue&type=template&id=db8b6ef0&"
import script from "./Hotspots_Edit.vue?vue&type=script&lang=js&"
export * from "./Hotspots_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports